// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(appBaseURL)
// ** START:  


export const newAttendanceSlice = createSlice({
    name: 'newAttendance',
    initialState: {
        newAttendance: { currentdate: '', dayworktype: '', in1: '', out1: '', in2: '', out2: '' }

    },
    reducers: {
        createNewAttendance: (state, action) => {
            state.newAttendance = action.payload
        },
        // New reducer to update individual fields, ie in1, out1...
        updateNewAttendance: (state, action) => {
            const { field, value } = action.payload
            state.newAttendance[field] = value
        }
    }
})


export const getAttendanceListF01Data = createAsyncThunk('appAttendance/getAttendanceListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller } = params

        let data
        let tempIsDataLoaded

        if (!state.attendance.attendanceListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/Attendance/GetAttendanceListF01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getAttendanceListF01Data', response.statusText)
            }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.attendance.attendanceListF01.allData
            tempIsDataLoaded = state.attendance.attendanceListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:

        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            if (a[sortColumn]) {
                return a[sortColumn] < b[sortColumn] ? -1 : 1
            } else {
                const splitColumn = sortColumn.split('.')
                const columnA = a[splitColumn[0]][splitColumn[1]]
                const columnB = b[splitColumn[0]][splitColumn[1]]
                return columnA < columnB ? -1 : 1
            }
        })

        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            attendance => { 
                return ((attendance.name.toLowerCase().includes(queryLowered) ||
                        attendance.contact.toLowerCase().includes(queryLowered) ||
                        attendance.email.toLowerCase().includes(queryLowered)) 
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const attendanceListF01Slice = createSlice({
    name: 'attendanceListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getAttendanceListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getAttendanceListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getAttendanceListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getAttendanceListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})


// ** START:  
export const getAttendanceRowF01Data = createAsyncThunk('appAttendance/getAttendanceRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/Attendance/GetAttendanceRowF01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getAttendanceRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getAttendanceRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const attendanceRowF01Slice = createSlice({
    name: 'attendanceRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getAttendanceRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getAttendanceRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getAttendanceRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getAttendanceRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateAttendance = createAsyncThunk('appAttendance/updateAttendance', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/Attendance/UpdateAttendance/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const attendanceUpdateSlice = createSlice({
    name: 'attendanceUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateAttendance.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateAttendance.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateAttendance.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateAttendance:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createAttendance = createAsyncThunk('appAttendance/createAttendance', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/Attendance/CreateAttendance`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const attendanceCreateSlice = createSlice({
    name: 'attendanceCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createAttendance.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createAttendance:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createAttendance.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createAttendance.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createAttendance\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteAttendance = createAsyncThunk('appAttendance/deleteAttendance', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/Attendance/DeleteAttendance/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const attendanceDeleteSlice = createSlice({
    name: 'attendanceDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteAttendance.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteAttendance.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteAttendance.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteAttendance:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Export actions
export const { setIsDataLoaded } = attendanceListF01Slice.actions
export const { createNewAttendance, updateNewAttendance } = newAttendanceSlice.actions
export const { resetCreateState } = attendanceCreateSlice.actions

// Combine reducers
const attendanceReducer = combineReducers({
    attendanceListF01: attendanceListF01Slice.reducer,
    attendanceRowF01: attendanceRowF01Slice.reducer,
    attendanceCreate: attendanceCreateSlice.reducer,
    attendanceUpdate: attendanceUpdateSlice.reducer,
    attendanceDelete: attendanceDeleteSlice.reducer,
    newAttendance: newAttendanceSlice.reducer
})


export default attendanceReducer